import { useTranslation } from 'react-i18next';
import styles from './CapacityLimitCell.module.css';

interface CapacityLimitCellProps {
  value: number | undefined;
  isEditing: boolean;
  editingValue: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const CapacityLimitCell = ({
  value,
  isEditing,
  editingValue,
  onChange,
  onSave,
  onCancel
}: CapacityLimitCellProps) => {
  const { t } = useTranslation();

  if (!isEditing) {
    return <span>{value ?? t('capacity-limit-none')}</span>;
  }

  return (
    <input
      className={styles.input}
      type="number"
      min={1}
      value={editingValue}
      placeholder={t('capacity-limit-placeholder')}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onSave();
        else if (e.key === 'Escape') onCancel();
      }}
    />
  );
};
